var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "holder" }, [
      _c(
        "h2",
        { attrs: { id: "page-header" } },
        [
          _c("router-link", { attrs: { to: "/" } }, [_vm._v("My Arlington -")]),
          _c("router-link", { attrs: { to: "/apartments" } }, [
            _vm._v(" Apartments & Condos")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layer-page" }, [
      _c("div", { staticClass: "widget one-third filter-pane" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMobile || _vm.mobileMenu === false,
                expression: "isMobile || mobileMenu === false"
              }
            ],
            staticClass: "filter-header",
            attrs: {
              type: "button",
              id: "mobile-menu",
              "aria-expanded": _vm.mobileMenu ? "true" : "false",
              "aria-controls": "filters-and-settings"
            },
            on: {
              click: function($event) {
                _vm.mobileMenu = !_vm.mobileMenu
              }
            }
          },
          [
            _vm._v("\n                Filters and Location\n                "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.mobileMenu,
                    expression: "!mobileMenu"
                  }
                ],
                staticClass: "icon",
                staticStyle: { float: "right" },
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mobileMenu,
                    expression: "mobileMenu"
                  }
                ],
                staticClass: "icon",
                staticStyle: { float: "right" },
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isMobile || _vm.mobileMenu,
                expression: "!isMobile || mobileMenu"
              }
            ],
            attrs: { id: "filters-and-settings" }
          },
          [
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isMobile,
                      expression: "!isMobile"
                    }
                  ],
                  staticClass: "filter-header",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.filtersExpanded ? "true" : "false",
                    "aria-controls": "apartments-filter-list"
                  },
                  on: { click: _vm.filtersToggle }
                },
                [
                  _c("span", [
                    _vm._v("Filters\n                            "),
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filtersExpanded,
                            expression: "filtersExpanded"
                          }
                        ],
                        staticClass: "icon",
                        staticStyle: { float: "right" },
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
                    ),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.filtersExpanded,
                            expression: "!filtersExpanded"
                          }
                        ],
                        staticClass: "icon",
                        staticStyle: { float: "right" },
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticStyle: { clear: "both", display: "block" }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.filtersExpanded || _vm.mobileMenu,
                      expression: "filtersExpanded || mobileMenu"
                    }
                  ],
                  staticClass: "filterList",
                  attrs: { id: "apartments-filter-list" }
                },
                [
                  _c("div", { staticClass: "filter-item filter-category" }, [
                    _vm._v("Type")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "filter-item" }, [
                    _c("label", { staticClass: "filter-checkbox-label" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.typeSelected,
                            expression: "typeSelected"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: "Apartment",
                          checked: Array.isArray(_vm.typeSelected)
                            ? _vm._i(_vm.typeSelected, "Apartment") > -1
                            : _vm.typeSelected
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.typeSelected,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Apartment",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.typeSelected = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.typeSelected = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.typeSelected = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tooltip" }, [
                        _vm._v(" Apartment")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "filter-item" }, [
                    _c("label", { staticClass: "filter-checkbox-label" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.typeSelected,
                            expression: "typeSelected"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: "Condominium",
                          checked: Array.isArray(_vm.typeSelected)
                            ? _vm._i(_vm.typeSelected, "Condominium") > -1
                            : _vm.typeSelected
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.typeSelected,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Condominium",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.typeSelected = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.typeSelected = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.typeSelected = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tooltip" }, [_vm._v(" Condo")])
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c("label", { attrs: { for: "civicAssociation" } }, [
                _vm._v("Civic Association")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.civicAssocationsSelected,
                        expression: "civicAssocationsSelected"
                      }
                    ],
                    attrs: { id: "civicAssociation" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.civicAssocationsSelected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Select a civic association")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.civicAssociations, function(ca) {
                      return _c(
                        "option",
                        { key: ca.OBJECTID, domProps: { value: ca } },
                        [_vm._v(_vm._s(ca.LABEL))]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.civicAssociationFailure,
                      expression: "civicAssociationFailure"
                    }
                  ]
                },
                [_vm._v("Unable to load Civic Assocations.")]
              )
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Zoom to Location")]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  staticClass: "filter-header",
                  on: { click: _vm.getCurrentLocation }
                },
                [_vm._v("Your Current Location")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-container zoom-container" },
              [
                _c("label", { attrs: { for: "addressSearch" } }, [
                  _vm._v("Address")
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("gmap-autocomplete", {
                  ref: "autocomplete",
                  attrs: {
                    id: "addressSearch",
                    placeholder: "Enter street address"
                  },
                  on: { place_changed: _vm.placeChanged }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  staticClass: "link filter-header",
                  on: { click: _vm.clearAll }
                },
                [_vm._v("Clear All")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "widget full-map-pane toggle-window" },
        [
          _c("div", { staticStyle: { position: "relative", top: "0" } }, [
            _c(
              "div",
              {
                staticClass: "toggle-bar",
                attrs: { role: "group", "aria-label": "Map or list" }
              },
              [
                _c(
                  "button",
                  {
                    class:
                      _vm.showMap === true
                        ? "toggle-link"
                        : "toggle-link active",
                    attrs: {
                      type: "button",
                      "aria-pressed": _vm.showMap === true
                    },
                    on: {
                      click: function($event) {
                        _vm.showMap = true
                      }
                    }
                  },
                  [_vm._v("Map")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class:
                      _vm.showMap === false
                        ? "toggle-link"
                        : "toggle-link active",
                    attrs: {
                      type: "button",
                      "aria-pressed": _vm.showMap === false,
                      id: "list-link"
                    },
                    on: {
                      click: function($event) {
                        _vm.showMap = false
                      }
                    }
                  },
                  [_vm._v("List")]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "gmap-map",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMap,
                  expression: "showMap"
                }
              ],
              attrs: {
                center: _vm.mapCenter,
                zoom: _vm.zoomLevel,
                options: _vm.mapStyles,
                id: "vue-map-container",
                "aria-label": "Map of apartment and condo locations"
              }
            },
            [
              _vm._l(_vm.filteredApartments, function(apartment) {
                return _c("gmap-marker", {
                  key: apartment.id,
                  attrs: {
                    position: apartment,
                    icon: _vm.icon,
                    options: _vm.shapeOptions
                  },
                  on: {
                    click: function(e) {
                      return _vm.shapeClick(apartment, e)
                    }
                  }
                })
              }),
              _vm._v(" "),
              _c(
                "gmap-info-window",
                {
                  attrs: {
                    opened: _vm.selectedInfoWindowPosition !== null,
                    position: _vm.selectedInfoWindowPosition
                  },
                  on: { closeclick: _vm.infoWindowCloseClick }
                },
                [
                  _c("div", { staticClass: "info-window" }, [
                    _c("b", {
                      domProps: {
                        innerHTML: _vm._s(_vm.selectedItem.complexName)
                      }
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.selectedItem.complexTypeName))
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.selectedItem.complexStreetNbrNameText))
                    ]),
                    _vm._v(" "),
                    _vm.selectedItemCivic
                      ? _c("span", [
                          _c("br"),
                          _c("br"),
                          _vm._v("\n                          Within the "),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.selectedItemCivic.civicAssociationName)
                            )
                          ]),
                          _vm._v(
                            " civic association.\n                          "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                          " +
                              _vm._s(_vm.selectedItemCivic.contactTitleName) +
                              " - " +
                              _vm._s(_vm.selectedItemCivic.contactName) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                          " +
                              _vm._s(
                                _vm.selectedItemCivic.firstContactEmailText
                              ) +
                              "\n                        "
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.selectedCoordinates
                ? _c("gmap-marker", {
                    attrs: { position: _vm.selectedCoordinates, radius: 24 }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.civicAssocationsSelected
                ? _c("gmap-polygon", {
                    attrs: {
                      path: _vm.civicAssocationsSelected.paths,
                      options: _vm.locationOptions
                    }
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showMap,
                  expression: "!showMap"
                }
              ],
              staticClass: "list-pane"
            },
            _vm._l(_vm.filteredApartments, function(apartment) {
              return _c("div", { key: apartment.id, staticClass: "project" }, [
                _c("h3", { staticClass: "h3-list" }, [
                  apartment.complexName
                    ? _c("span", {
                        domProps: { innerHTML: _vm._s(apartment.complexName) }
                      })
                    : _c("span", [_vm._v("Apartment or condo")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "no-vertical-margin" }, [
                  _c("span", [_vm._v(_vm._s(apartment.complexTypeName))]),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(apartment.complexStreetNbrNameText))
                  ]),
                  _vm._v(" "),
                  _c("br")
                ])
              ])
            }),
            0
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "blurb" } }, [
      _c("p"),
      _vm._v(" "),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c9f18f6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9f18f6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apartments/Apartments.vue
// module id = Y8mR
// module chunks = 1